import { login, logout, getMenuList, sendVerificationCode, formalLogin, sendSmsCode, updatePwd } from '@/api/login'
import { getToken, removeToken } from '@/utils/auth'

export default {
  namespaced: true,
  state: {
    menuList: [],
    token: getToken()
  },
  actions: {
    // 密码登录
    login(ctx, payload) {
      return login(payload)
    },

    // 发送短信验证获取验证码
    sendVerificationCode(ctx, payload) {
      return sendVerificationCode(payload)
    },

    // 发送短信验证获取验证码
    sendSmsCode(ctx, payload) {
      return sendSmsCode(payload)
    },

    // 新登录接口
    formalLogin(ctx, payload) {
      return formalLogin(payload)
    },



    logout({ state }) {
      return logout().finally(() => {
        sessionStorage.removeItem('menulist')

        localStorage.clear()
        state.token = ''
        removeToken()
      })
    },

    updatePwd(ctx, payload) {

      return updatePwd(payload).then(res => {
        // if (res && res.status === 200) {
        //   sessionStorage.menulist = JSON.stringify(res.data)
        //   return res.data
        // } else {
        //   return []
        // }
        return res
      })
    },



    getMenuList(ctx, payload) {
      const cache = sessionStorage.menulist;

      try {
        if (cache) { return JSON.parse(cache) }
      } catch (e) { }

      return getMenuList(payload).then(res => {
        if (res && res.status === 200) {
          sessionStorage.menulist = JSON.stringify(res.data)
          return res.data
        } else {
          return []
        }
      })
    }
  }
}
